exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AgencyAnalyticsHome_content__2W0ko {\n  background-color: #f4f8f9;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n  width: 100%; }\n  .AgencyAnalyticsHome_content__2W0ko .AgencyAnalyticsHome_title__3Ujj0 {\n    color: #044591;\n    margin: 0 10px 0 0; }\n  .AgencyAnalyticsHome_content__2W0ko .AgencyAnalyticsHome_tabAnalytics__2LDxs.MuiTab-root {\n    min-width: unset;\n    padding: 0px 5px; }\n", ""]);

// exports
exports.locals = {
	"content": "AgencyAnalyticsHome_content__2W0ko",
	"title": "AgencyAnalyticsHome_title__3Ujj0",
	"tabAnalytics": "AgencyAnalyticsHome_tabAnalytics__2LDxs"
};